module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_8019.119cfbe2.png";